// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a7vy","label":"styles_label__1Ba56"};